import apiClient, { SYSTEM_TOKEN } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';

export const getMonasteryList = async () => {
  const response = await apiClient.post(ENDPOINTS.MONASTERY.LIST, { only_monastery: false }, {
    headers: { 'X-Auth-Token': SYSTEM_TOKEN }
  });
  return response.items.map((item) => ({
    id: item.monastery_id,
    name: item.monastery_name,
  }));
};
